/**
 * @requires ./frc.js
 */

frc.api = {
	"core": {
		"geocode": function(query, callback){
			var self = frc.api;
			if(!callback || !query){
				return;
			}
			self.common.performRequest({
				"async": true,
				"crossDomain": true,
				"url": frcContext.apiBaseUrl + "geocode?query=" + window.escape(query),
				"method": "GET"
			}, function(response){

				if(response&&response.success){
					callback(response);
				} else {
					if(window.frc && frc.page && frc.page.data && !frc.page.data.geocoder && (typeof google) != "undefined" && (typeof google.maps) != "undefined" && (typeof google.maps.Geocoder) != "undefined"){
						frc.page.data.geocoder = new google.maps.Geocoder();
					}

					if(!window.frc || !frc.page || !frc.page.data || !frc.page.data.geocoder){
						callback({
							"success": false
						});
						return;
					}

					// See https://developers.google.com/maps/documentation/javascript/reference/3.exp/geocoder#Geocoder.geocode
					frc.page.data.geocoder.geocode({
						"address": query,
						"bounds": { // Restrict to 'Murica
							"north": 49.3457868,
							"east": 66.9513812,
							"south": 24.7433195,
							"west": -124.7844079
						}
					}, function(result, status){
						if(status==google.maps.GeocoderStatus.OK && result.length && result[0].address_components){

							function getAddressComponent(addressComponents, key){
								var ret = addressComponents.find(function(addressComponent){
									return addressComponent.types && addressComponent.types.indexOf(key) > -1;
								});
								if(ret){
									ret = ret.short_name;
								}
								return ret;
							}

							var ret = {
								"city": getAddressComponent(result[0].address_components, "locality"),
								"state": getAddressComponent(result[0].address_components, "administrative_area_level_1"),
								"zip": getAddressComponent(result[0].address_components, "postal_code"),
								"latitude": result[0].geometry.location.lat(),
								"longitude": result[0].geometry.location.lng()
							};
							
							callback({
								"success": true,
								"data": ret
							});

						} else {
							callback({
								"success": false
							});
							return;
						}
					});
				}

			});
		},
		"getBrandInfo": function(brandId, callback){
			var self = frc.api;
			url = frcContext.apiBaseUrl + "brands";
			if(brandId){
				url += "/" + brandId;
			}
			self.common.performRequest({
				"async": true,
				"crossDomain": true,
				"url": url,
				"method": "GET"
			}, callback);
		},
		"careers": {
			"getCategories": function(brandId, callback){
				var self = frc.api;
				url = frcContext.apiBaseUrl + "careers/categories";
				if(brandId){
					url += "?brand_id=" + brandId;
				}
				self.common.performRequest({
					"async": true,
					"crossDomain": true,
					"url": url,
					"method": "GET"
				}, callback);
			}
		},
		"ebites": {
			"signup": function(data, callback){
				var self = frc.api;
				if(!callback || !data){
					return;
				}
				self.common.performRequest({
					"async": true,
					"crossDomain": true,
					"url": frcContext.apiBaseUrl + "ebites/subscribers",
					"method": "PATCH",
					"headers": {
						"content-type": "application/x-www-form-urlencoded"
					},
					"data": data
				}, callback);
			}
		},
		"getJobs": function(brandId, callback){
			var self = frc.api;
			url = frcContext.apiBaseUrl + "careers";
			if(brandId){
				url += "?brand_id=" + brandId;
			}
			self.common.performRequest({
				"async": true,
				"crossDomain": true,
				"url": url,
				"method": "GET"
			}, callback);
		}
	},
	"brand": {
		"getLocations": function(callback){
			var self = frc.api;

			self.common.performRequest({
				"async": true,
				"crossDomain": true,
				"url": "/api/?action=get-all-locations",
				"method": "GET"
			}, callback);
		},
		"getJobCategories": function(callback){
			frc.api.core.careers.getCategories(frcContext.brand.id, callback);
		}
	},
	"common": {
		"performRequest": function(settings, callback){
			if(!frc.data.userIsLeavingPage){
				jQuery.ajax(settings).done(function(response){
					if(response.data){
						callback({
							"success": true,
							"data": response.data
						});
					} else {
						callback({ "success": false });
					}
				});
			}
		}
	}

};